//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data: function () {
    return {
      service: {},
      currentUrl: "",

      isSsrModal: false
    }
  },

  props: {
    slug: {
      type: String,
      default: ""
    },
    disableChangeUrl: {
      type: Boolean,
      default: false
    },
    initService: {
      type: Object,
      default: () => {
        return {}
      }
    },
    links: {
      type: Array,
      default: () => {
        return []
      }
    },
    message: {
      type: String,
      default: ''
    }
  },

  created: function () {
    if (Object.keys(this.initService).length > 0) {
      this.service = this.initService;
      this.isSsrModal = true;
      this.currentUrl = `/uslugi/${this.initService.category.slug}`
    }
  },

  computed: {

    // Стоимость услуги
    servicePrice: function() {
      if (!this.service.price || this.service.price === 0) {
        return "бесплатно";
      }

      return `${this.service.price} ₽`
    },
    servicePriceOld: function() {
      if (!this.service.price_old || this.service.price_old <= this.service.price) {
        return;
      }

      return `${this.service.price_old} ₽`;
    },

    // Длительность услуги
    serviceDuration: function() {
      const duration = this.service.duration;

      const hours = Math.floor(duration / 60);
      const minuts = duration - (hours * 60);

      return [
        !!hours ? `${hours} ${this.$caseWords(hours, ['час', 'часа', 'часов'])}` : undefined,
        !!minuts ? `${minuts} ${this.$caseWords(minuts, ['минута', 'минуты', 'минут'])}` : undefined,
      ].join(' ')
    }
  },

  methods: {
    open: function (service) {
      const currentUrl = this.$route.path;
      const replaceUrl = `/uslugi/${service?.category?.slug}/${service.slug}`;

      this.service = service;
      this.currentUrl = currentUrl;

      this.$modal.show("service-card-modal");

      if (this.disableChangeUrl) {
        return null
      }

      window.history.replaceState(null, null, replaceUrl);
    },

    // Запись на прием
    onMakeAppointment: function() {

    },

    // Закртие модального окна
    close: function() {
      this.service = {};
      this.$emit("close");

      if (this.isSsrModal) {
        this.isSsrModal = false;
        this.$router.replace(this.currentUrl);
      } else {
        window.history.replaceState(null, null, this.currentUrl);
      }
    },

    // Запись на прием
    click: function() {
      this.$emit('click', this.service.id);
      this.close();
    }
  }

};
